/**
 * True when this tab's bundled JS predates the build currently being served.
 * A refresh-token call from stale code never entered the current bundle's
 * cross-tab Web Locks serialization (lib/auth/refresh-token-lock.ts) — the
 * lock name and code path are only in memory for whatever tabs loaded the
 * fix — so it can still race a freshly-loaded tab's refresh and trip the
 * backend's replay detection. Callers should force a reload instead of
 * refreshing when this returns true, so the stale tab re-enters on the
 * current, correctly-serialized bundle.
 *
 * Fails open (false) on any error: a flaky freshness check should never block
 * a legitimate token refresh over the rare race it's guarding against.
 */
export async function isRunningStaleBuild(): Promise<boolean> {
  try {
    const response = await fetch('/api/build-info', { cache: 'no-store' })
    if (!response.ok) return false
    const data = (await response.json()) as { buildId?: string }
    const clientBuildId = process.env.NEXT_PUBLIC_BUILD_ID ?? 'dev'
    return Boolean(data.buildId) && data.buildId !== clientBuildId
  } catch {
    return false
  }
}
